export default __webpack_public_path__ + "b3316d0fd195afdbb9ec1ce8013bb8e7.png";